import { progressUpdate } from '@/assets/js/util';
import { mapState } from 'vuex';

export const resumeMixin = {
  data() {
    return {
      percentage: 0,
      token: '',
      fileImage: '',
      fileName: '',
      cancelCallback: null,
    };
  },
  methods: {
    beforeCreateResume(data) {
      this.percentage = 0;
      this.fileImage = data.fileImage;
      this.fileName = data.fileName;
      this.cancelCallback = progressUpdate(
        (progress) => {
          this.percentage = progress;
        },
        () => {},
        data.maxPercent,
      );
    },
    resumeChange(token) {
      this.token = token;
      this.percentage = 100;
      this.cancelCallback?.();
    },
  },
};

export const breakResumeMixin = {
  computed: {
    ...mapState('me', ['personInfo', 'isMembership']),
    isForeverMember() {
      return (
        this.isMembership && (this.personInfo.membership_expired_at || '').substr(0, 4) >= 2100
      );
    },
  },
  methods: {
    memberResumeLimit(res) {
      const message = this.isForeverMember ? res.message : '简历已满，开通终身会员提升至15份';
      this.$message.error(message);
      if (!this.isForeverMember) {
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'upVip',
          memberBreakConfig: {
            type: this.isForeverMember ? '' : 'forever',
            message: this.isForeverMember ? '' : '仅终身会员可解锁更多简历份数',
          },
        });
      }
    },
  },
};
